import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { AuthenticationService } from 'app/core/index';

@Injectable()
export class BalanceHistoryService {
  /**
   * @param {Http} http
   * @param {AuthenticationService} auth
   */
  constructor(private http: Http, private auth: AuthenticationService) {}

  /**
   * @returns {Promise<Response>}
   */
  public withdrawRequests(page: number = 1) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('page', page.toString());

    options.search = params;
    options.headers = this._headers();
    return this.http
      .get('/api/history/withdraw-requests', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  /**
   * @returns {Promise<Response>}
   */
  public depositsAndWithdraws(page: number = 1) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('page', page.toString());

    options.search = params;
    options.headers = this._headers();
    return this.http
      .get('/api/history/deposits-withdraws', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  /**
   * @param requestId
   */
  public cancelWithdrawalRequest(requestId: string) {
    const options: RequestOptions = new RequestOptions();
    options.headers = this._headers();
    return this.http
      .delete(`/api/withdraw/${requestId}`, options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public gameHistory(game: string, page: number = 1, from: string, to: string) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('game', game);
    params.set('page', page.toString());
    params.set('from', from);
    params.set('to', to);

    options.search = params;
    options.headers = this._headers();

    return this.http
      .get('/api/history/games', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public gameDetails(game: string) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();

    params.set('game', game);

    options.search = params;
    // options.headers = this._headers();

    return this.http
      .get('/api/history/game-details', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  /*public lastGamesData(game: string) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();

    params.set('game', game);

    options.search = params;
    // options.headers = this._headers();

    return this.http
      .get('/api/history/last-games', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }*/

  public gameTotals(from: string, to: string) {
    const options: RequestOptions = new RequestOptions();
    const params = new URLSearchParams();
    params.set('from', from);
    params.set('to', to);

    options.search = params;
    options.headers = this._headers();

    return this.http
      .get('/api/history/totals', options)
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  /**
   * @returns {Headers}
   * @private
   */
  private _headers(): Headers {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return headers;
  }

  /**
   * @returns {{headers: Headers}}
   * @private
   */
  private _options() {
    return {
      headers: this._headers(),
    };
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/account/balance-history.service.ts